import { useMemo } from "react";
import { t } from "@/i18n-js/instance";
import type { RadioFilterParam } from "@/react/components/shared/Filter/FilterTypes/RadioFilterV2";
import { RadioFilterV2 as RadioFilter } from "@/react/components/shared/Filter/FilterTypes/RadioFilterV2";
import type { BaseFilter } from "@/react/components/shared/MemberFilters/types";
import { Filter } from "@circle-react-shared/FilterV3";
import { FilterChip } from "../../shared/FilterV3/FilterChipV2";
import { useFilterProvider } from "../FilterProvider";
import type { BooleanFilterConfiguration } from "../types";

interface BooleanFilterInputProps {
  configuration: BooleanFilterConfiguration;
}

// This component is not used in the FilterKit yet so implementation might not be correct
export const BooleanFilterInput = ({
  configuration,
}: BooleanFilterInputProps) => {
  const { setFilter, filterParamForKey, clearFilterByKey } =
    useFilterProvider();

  const param = useMemo((): RadioFilterParam => {
    const existingFilter = filterParamForKey(configuration.key);

    return {
      id: configuration.key,
      key: configuration.key,
      value: (existingFilter?.value as string) ?? "",
    };
  }, [filterParamForKey, configuration.key]);

  const options = [
    {
      label: t("boolean_filter_options.yes"),
      value: "true",
    },
    {
      label: t("boolean_filter_options.no"),
      value: "false",
    },
  ];

  const handleApply = (value: BaseFilter | null) => {
    if (value === null) {
      clearFilterByKey(configuration.key);
    } else {
      setFilter(configuration.key, {
        ...value,
        search_key: configuration.search_key,
      });
    }
  };

  return (
    <Filter onApply={handleApply}>
      <FilterChip renderSelectedValue={() => param.value}>
        {configuration.label}
      </FilterChip>
      <Filter.Popover title={configuration.label}>
        <RadioFilter
          options={options}
          param={param}
          legend={configuration.label}
        />
      </Filter.Popover>
    </Filter>
  );
};
